import './main-header/main-header.component';
import './notifications/notifications.component';
import './sidebar-nav/sidebar-nav.component';
import './toggle-switch/toggle-switch.component';
import './modal-confirm/modal-confirm.component';
import './spinner/spinner.component';
import './datetime-range-picker/datetime-range-picker.component';

import './component-controller';



// WEBPACK FOOTER //
// ./common/components/index.js